import type { SVGProps } from 'react';

const SvgInformationFill = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2.5 2a1 1 0 0 1 1-1H13v5a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2v-3h-.5a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgInformationFill;
